import { render, staticRenderFns } from "./Blog5.vue?vue&type=template&id=6e55f3c3"
import script from "./Blog5.vue?vue&type=script&lang=js"
export * from "./Blog5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports